import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJcb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.46797 0.45459C1.07443 0.45459 0.000244141 1.36245 0.000244141 2.94387V7.45387C0.116372 8.01029 0.697013 8.42029 1.33572 8.42029C2.06152 8.42029 2.58409 7.89315 2.58409 7.24887V4.96458H4.55827V7.21958C4.55827 8.47887 2.96151 9.12315 1.80023 9.12315C1.13249 9.12315 0.493789 8.91815 0.0292762 8.56672V13.5453H3.16473C4.26795 13.5453 5.54536 12.491 5.54536 11.1439V0.45459H2.46797Z",
			fill: "#1174CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.000244141 2.94387V7.45387C0.116372 8.01029 0.697013 8.42029 1.33572 8.42029C2.06152 8.42029 2.58409 7.89315 2.58409 7.24887V4.96458H4.55827V7.21958C4.55827 8.47887 2.96151 9.12315 1.80023 9.12315C1.13249 9.12315 0.493789 8.91815 0.0292762 8.56672V13.5453H3.16473C4.26795 13.5453 5.54536 12.491 5.54536 11.1439V0.45459",
			fill: "#0F549D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.529 4.9646V7.2196C4.529 8.47888 2.93223 9.12317 1.77095 9.12317C1.10322 9.12317 0.464512 8.91817 0 8.56674V13.5453H3.13546C4.23868 13.5453 5.51609 12.491 5.51609 11.1439",
			fill: "#02375E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4419 8.36179H14.8064C15.1548 8.36179 15.4741 8.03965 15.4741 7.68822C15.4741 7.33679 15.1548 7.01465 14.8064 7.01465H13.4419V8.36179Z",
			fill: "#146643"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9806 0.45459C13.5581 0.45459 12.5129 1.36245 12.5129 2.91459V4.96458H16.171C16.6935 4.96458 17.129 5.40387 17.129 5.93101C17.129 6.45815 16.6935 6.89744 16.171 6.89744C16.7516 6.89744 17.2161 7.30744 17.2161 7.83458C17.2161 8.36172 16.7806 8.77172 16.171 8.77172H12.4839V13.5453H15.6193C16.7226 13.5453 18 12.491 18 11.1439V0.45459H14.9806Z",
			fill: "#1BCC38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4839 2.94387V4.96458H16.1419C16.6645 4.96458 17.1 5.40387 17.1 5.93101C17.1 6.45815 16.6645 6.89744 16.1419 6.89744C16.7226 6.89744 17.1871 7.30744 17.1871 7.83458C17.1871 8.36172 16.7516 8.77172 16.1419 8.77172H12.4839V13.5453H15.6193C16.7226 13.5453 18 12.491 18 11.1439V0.45459",
			fill: "#329947"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0997 5.9314C17.0997 6.45854 16.6643 6.89782 16.1417 6.89782C16.7223 6.89782 17.1868 7.30782 17.1868 7.83496C17.1868 8.36211 16.7514 8.77211 16.1417 8.77211H12.4836V13.5457H15.6191C16.7223 13.5457 17.9997 12.4914 17.9997 11.1442",
			fill: "#146643"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4449 6.04833C15.4449 5.6969 15.1255 5.37476 14.7771 5.37476H13.4417V6.69261H14.8062C15.1545 6.69261 15.4449 6.39975 15.4449 6.04833Z",
			fill: "#146643"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.68037 0.45459C7.2578 0.45459 6.21265 1.36245 6.21265 2.91459V5.43316C6.56103 5.1403 6.99651 4.9353 7.46102 4.9353H10.7707V5.63815C9.98681 5.46244 9.23198 5.37458 8.85456 5.37458C8.04166 5.37458 7.37393 6.04815 7.37393 6.86815C7.37393 7.68815 8.04166 8.36172 8.85456 8.36172C9.23198 8.36172 9.98681 8.30315 10.7707 8.12744V8.77172H7.46102C6.99651 8.77172 6.532 8.59601 6.21265 8.27387V13.5453H9.3481C10.4513 13.5453 11.7287 12.491 11.7287 11.1439V0.45459H8.68037Z",
			fill: "#E20E37"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.21265 2.94387V5.46244C6.56103 5.16958 6.99651 4.96458 7.46102 4.96458H10.7707V5.66744C9.98681 5.49173 9.23198 5.40387 8.85456 5.40387C8.04166 5.40387 7.37393 6.07744 7.37393 6.89744C7.37393 7.71744 8.04166 8.39101 8.85456 8.39101C9.23198 8.39101 9.98681 8.33244 10.7707 8.15672V8.77172H7.46102C6.99651 8.77172 6.532 8.59601 6.21265 8.27387V13.5453H9.3481C10.4513 13.5453 11.7287 12.491 11.7287 11.1439V0.45459",
			fill: "#B41F36"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7707 4.9646V5.66746C9.98681 5.49174 9.23198 5.40388 8.85456 5.40388C8.04166 5.40388 7.37393 6.07746 7.37393 6.89745C7.37393 7.71745 8.04166 8.39102 8.85456 8.39102C9.23198 8.39102 9.98681 8.33245 10.7707 8.15674V8.77174H7.46102C6.99651 8.77174 6.532 8.59602 6.21265 8.27388V13.5453H9.3481C10.4513 13.5453 11.7287 12.491 11.7287 11.1439",
			fill: "#720A1E"
		})
	]
});
export default SvgJcb;
